import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function AcquirelySection() {
  return <section className="py-24 bg-brand-white" data-id="element-35">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-36">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-37">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-38">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-black mb-6" data-id="element-39">
              From Research to Action
            </h2>
            <p className="text-xl text-gray-600 font-light mb-8 leading-relaxed" data-id="element-40">
              The findings from this national study directly informed the design
              of{' '}
              <strong className="text-brand-black font-semibold" data-id="element-41">
                Inclusive Succession by Acquirely
              </strong>
              .
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-42">
              A program built to help underrepresented entrepreneurs navigate
              entrepreneurship through acquisition with greater access, clarity,
              and support.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 mt-10" data-id="element-43">
              <div className="flex-1 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-44">
                <div className="text-sm text-brand-teal font-bold uppercase tracking-wider mb-2" data-id="element-45">
                  Step 1
                </div>
                <div className="font-serif text-xl font-bold text-brand-black" data-id="element-46">
                  The Foundation
                </div>
                <p className="text-gray-500 text-sm mt-2" data-id="element-47">
                  This national research study
                </p>
              </div>
              <div className="hidden sm:flex items-center justify-center text-gray-300" data-id="element-48">
                <ArrowRight className="w-8 h-8" data-id="element-49" />
              </div>
              <div className="flex-1 bg-brand-teal/5 p-6 rounded-xl border border-brand-teal/20" data-id="element-50">
                <div className="text-sm text-brand-teal font-bold uppercase tracking-wider mb-2" data-id="element-51">
                  Step 2
                </div>
                <div className="font-serif text-xl font-bold text-brand-black" data-id="element-52">
                  The Pathway
                </div>
                <p className="text-gray-500 text-sm mt-2" data-id="element-53">
                  The Acquirely Program
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl bg-brand-black flex items-center justify-center p-12 text-center" data-id="element-54">
            <div className="absolute inset-0 bg-gradient-to-br from-brand-teal/20 to-transparent mix-blend-overlay" data-id="element-55"></div>
            <div className="relative z-10" data-id="element-56">
              <div className="text-white/50 font-medium tracking-widest uppercase text-sm mb-4" data-id="element-57">
                Coming Soon
              </div>
              <h3 className="font-serif text-4xl text-white font-bold mb-6" data-id="element-58">
                Inclusive Succession
                <br data-id="element-59" />
                by Acquirely
              </h3>
              <p className="text-gray-300 text-lg mb-8 max-w-sm mx-auto" data-id="element-60">
                Practical education, mentorship, and capital access for the next
                generation of diverse owners.
              </p>
              <button className="px-6 py-3 rounded-full border border-white/30 text-white hover:bg-white hover:text-brand-black transition-colors duration-300" data-id="element-61">
                Learn More About Acquirely
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}